import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  employeeNo: null,
  name: null,
  enName: null,
  div: null,
  resp: null,
  email: null,
  jd: null,
  id: null,
  permissions: [],
};

export const userInfoSlice = createSlice({
  name: "userInfo",
  initialState,
  reducers: {
    updateUserInfo: (state, action) => {
      return {
        ...state,
        employeeNo: action.payload.employeeNo,
        name: action.payload.name,
        enName: action.payload.enName,
        div: action.payload.div,
        resp: action.payload.resp,
        email: action.payload.email,
        jd: action.payload.jd,
        id: action.payload.id,
        permissions: action.payload.permissions ?? [],
      };
    },
    updateEmployeeNo: (state, action) => {
      if (action.payload) {
        return {
          ...state,
          employeeNo: action.payload,
        };
      } else {
        return {
          ...state,
          employeeNo: null,
          name: null,
          enName: null,
          div: null,
          resp: null,
          email: null,
          jd: null,
          id: null,
          permissions: [],
        };
      }
    },
  },
});

export const { updateUserInfo, updateEmployeeNo } = userInfoSlice.actions;

export default userInfoSlice.reducer;
